import { Typography, Stack } from '@mui/material';
import { AddServiceButton } from './shoppingCartStyles';
import { useTranslation } from 'react-i18next';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { useRouteNavigator } from '../../routes/useRouteNavigator';

interface CartServicesEmptyProps {
  hideAddServiceButton?: boolean;
}

export function CartServicesEmpty({ hideAddServiceButton }: CartServicesEmptyProps) {
  const routeNavigator = useRouteNavigator();
  const { t } = useTranslation();
  const addServiceClick = () => {
    if (appStyleMode === AppStyle.Mobile) {
      routeNavigator.goHome();
    } else {
      routeNavigator.goToSearch();
    }
  };

  return (
    <Stack
      className={appStyleMode === AppStyle.Mobile && 'shopping-cart-services-empty-list'}
      sx={{
        height: appStyleMode !== AppStyle.Mobile ? '270px' : null,
        color: '#b5b5b5',
      }}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <SentimentDissatisfiedIcon
        sx={{
          height: '50px',
          width: '50px',
        }}
      />
      <Typography sx={{ fontStyle: 'italic', fontSize: '30px', fontWeight: 'lighter' }}>
        {t('payment:emptyCart')}
      </Typography>
      {!hideAddServiceButton && (
        <AddServiceButton variant="contained" onClick={addServiceClick}>
          {t('payment:add')}
        </AddServiceButton>
      )}
    </Stack>
  );
}
